module.exports = __webpack_public_path__ + "static/media/readiness-remove.c01b6c28.svg";